export default __webpack_public_path__ + "static/media/Mentorship-Black.2190be36.svg";